export default __webpack_public_path__ + "static/media/guide_img_2.fc63c0fc.png";